import { convertMilliseconds } from './stats';

export const getTotalPrayerHubsLabel = (totalDuration: number) => {
  const { days, hours, minutes, seconds } = convertMilliseconds(totalDuration);

  if (days >= 1) return `${days} ימים ו-${hours} שעות של נתינה לאחר`;
  if (hours < 24 && hours > 1) return `${hours} שעות ו-${minutes} דקות של נתינה לאחר`;
  if (minutes > 0 && minutes < 60) return `${minutes} דקות של נתינה לאחר`;

  return `${seconds} שניות של נתינה לאחר`;
};
